import { Injectable } from '@angular/core';
import { PresenceGQL } from './presence-gql.service';
import { Observable } from 'rxjs';
import { tap, finalize, catchError } from 'rxjs/operators';

import { PresenceSubscription } from 'src/generated/voice-presence-api/graphql';
import { FetchResult } from '@apollo/client/core';
import { LogService } from './log.service'; // assume this is your logger
import { LogModule } from './log.service';

@Injectable({
  providedIn: 'root',
})
export class PresenceService {
  constructor(
    private presenceGQL: PresenceGQL,
    private logService: LogService
  ) {}

  subscribe(eveUserName: string): Observable<FetchResult<PresenceSubscription>> {
    const startTime = Date.now();
    this.logService.logInfo(
      `📡 Subscribing to Presence updates for ${eveUserName}\n`,
      LogModule.GRAPHQL
    );

    return this.presenceGQL.subscribe({ eveUserName }).pipe(
      tap({
        next: () =>
          this.logService.logInfo(
            `✅ Received Presence update for ${eveUserName}\n`,
            LogModule.GRAPHQL
          ),
      }),
      catchError((err) => {
        this.logService.logError(
          `❌ Presence subscription error for ${eveUserName}: ${err.message}\n`,
          LogModule.GRAPHQL
        );
        throw err;
      }),
      finalize(() => {
        const duration = Date.now() - startTime;
        this.logService.logInfo(
          `📴 Unsubscribed from Presence for ${eveUserName} after ${duration} ms\n`,
          LogModule.GRAPHQL
        );
      })
    );
  }
}
